<template>
  <div id="views-page1">
    <!-- 头部 -->
    <HeaderTitle :title="title" :navIndex="2"></HeaderTitle>
    <!-- 内容 -->
    <div class="content">
      <!-- 左 -->
      <div class="left">
        <!-- 鸡舍情况 -->
        <div class="title" style="padding: 8px 0 0 50px">鸡舍情况</div>
        <!-- 下拉选中鸡舍 -->
        <div style="width: 96%; margin: 25px auto 10px">
          <el-select
            style="width: 100%"
            :popper-append-to-body="false"
            class="custom-select"
            v-model="keyName"
            placeholder="请选择鸡舍"
            @change="selectchange"
          >
            <el-option
              class="optionss"
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </div>
        <!-- 鸡舍情况 -->
        <div style="width: 96%; margin: 0 auto">
          <div class="jsqk-title">
            <span class="title" style="padding-left: 10px"
              >当前鸡舍：<span>{{ keyName }}</span></span
            >
          </div>
          <div class="jsqk" style="margin: 10px 0">
            <div
              class="jsqk-item"
              v-for="(item, index) in coopList"
              :key="index"
            >
              <div>{{ item.name }}</div>
              <div>
                <span>{{ item.num }}</span>
                <span>{{ item.unit }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 能耗分析 -->
        <div style="width: 96%; margin: 0 auto 10px">
          <div class="jsqk-title">
            <span class="title" style="padding: 0 10px">能耗分析</span>
          </div>
          <div
            id="echartsOne"
            style="width: 100%; height: 200px; margin: 10px 0"
          ></div>
        </div>
        <!-- 产量分析 -->
        <div style="width: 96%; margin: 0 auto 10px">
          <div class="jsqk-title">
            <span class="title" style="padding: 0 10px">产量分析</span>
          </div>
          <div
            id="echartsTwo"
            style="width: 100%; height: 225px; margin: 10px 0"
          ></div>
        </div>
      </div>
      <!-- 中间 -->
      <div class="center">
        <!-- 企业位置 -->
        <div class="center-one">
          <!-- 渲染地图 -->
          <baidu-map
            class="map"
            :center="{ lng: 115.282, lat: 36.62 }"
            :zoom="12"
            mapType="BMAP_HYBRID_MAP"
            :scroll-wheel-zoom="true"
          >
            <!-- 把馆陶圈起来 -->
            <bm-boundary
              name="馆陶县"
              :strokeWeight="5"
              strokeColor="blue"
              fillColor=""
            />
            <bm-marker
              v-for="(item, index) in mapList"
              :key="index"
              :position="item.position"
              :icon="{ url: item.icon, size: { width: 50, height: 70 } }"
            >
              <bm-info-window show="false" style="width: 320px; height: 160px">
                <div class="info">
                  <div style="margin: 5px 0; padding-top: 63px">
                    <img
                      style="padding-right: 10px"
                      src="../../assets/mingcheng.png"
                      alt=""
                    />
                    基地名称：{{ item.title }}
                  </div>
                  <div>
                    <img
                      style="padding-right: 10px"
                      src="../../assets/weizhi.png"
                      alt=""
                    />
                    基地位置：{{ item.address }}
                  </div>
                  <div style="margin: 5px 0">
                    <img
                      style="padding-right: 10px"
                      src="../../assets/ren12.png"
                      alt=""
                    />
                    联系人：{{ item.name }}
                  </div>
                  <div>
                    <img
                      style="padding-right: 10px"
                      src="../../assets/phone.png"
                      alt=""
                    />
                    联系方式：{{ item.phone }}
                  </div>
                </div>
              </bm-info-window>
            </bm-marker>
          </baidu-map>
        </div>
        <!-- 企业介绍 -->
        <div class="center-two">
          <div class="title" style="padding: 10px 0 0 55px">企业介绍</div>
          <div>
            <div class="center-two-list">
              <img :src="qyDetail.icon" alt="" />
              <div class="center-two-item">
                <div>企业名称：{{ qyDetail.name }}</div>
                <div>地址：{{ qyDetail.address }}</div>
                <div>联系方式：{{ qyDetail.phone }}</div>
                <div
                  style="
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 6;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                >
                  企业简介：{{ qyDetail.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右 -->
      <div class="right">
        <!-- 监控 -->
        <div class="right-one">
          <div class="title">监控</div>
          <div style="width: 98%; position: relative; margin: 15px auto 0">
            <iframe
              :src="jiankUrl"
              style="width: 100%; height: 245px"
              id="ysOpenDevice"
              ref="monitorVideo"
              allowfullscreen
            >
            </iframe>
            <div class="jiankabsolute">
              {{ keyName }}监控
              <i
                @click="iframedx"
                style="
                  position: absolute;
                  right: 20px;
                  cursor: pointer;
                  bottom: 10px;
                  font-size: 30px;
                  z-index: 100;
                "
                class="el-icon-full-screen"
              ></i>
            </div>
          </div>
        </div>
        <!-- 产值趋势 -->
        <div class="right-two">
          <div class="title">产值趋势</div>
          <div
            id="echarts-three"
            style="width: 100%; height: 240px; margin-top: 20px"
          ></div>
        </div>
        <!-- 产量趋势 -->
        <div class="right-three">
          <div class="title">产量趋势</div>
          <div
            id="echarts-filt"
            style="width: 100%; height: 240px; margin-top: 20px"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
// 引入头部
import HeaderTitle from "../../components/HeaderTitle.vue";
export default {
  components: {
    HeaderTitle,
  },
  data() {
    return {
      // 标题
      title: "智慧养鸡基地",
      // 下拉选中
      keyName: "美绿思生态农牧科技馆陶有限公司",
      // 鸡舍数据
      options: [
        {
          value: "1",
          label: "美绿思生态农牧科技馆陶有限公司",
        },
        {
          value: "2",
          label: "馆陶县佳凤蛋鸡养殖专业合作社",
        },
        {
          value: "3",
          label: "馆陶县百谷源养殖有限公司",
        },
      ],
      // 鸡舍情况
      coopList: [],
      // 鸡舍一情况
      coopList1: [
        {
          name: "蛋鸡数量",
          num: "56254",
          unit: "只",
        },
        {
          name: "鸡舍范围",
          num: "100",
          unit: "亩",
        },
        {
          name: "智能设施",
          num: "20",
          unit: "台",
        },
        {
          name: "工作人员",
          num: "130",
          unit: "人",
        },
        {
          name: "室内温度",
          num: "28",
          unit: "℃",
        },
        {
          name: "室内湿度",
          num: "50",
          unit: "%",
        },
      ],
      // 鸡舍二情况
      coopList2: [
        {
          name: "蛋鸡数量",
          num: "25254",
          unit: "只",
        },
        {
          name: "鸡舍范围",
          num: "50",
          unit: "亩",
        },
        {
          name: "智能设施",
          num: "17",
          unit: "台",
        },
        {
          name: "工作人员",
          num: "50",
          unit: "人",
        },
        {
          name: "室内温度",
          num: "27",
          unit: "℃",
        },
        {
          name: "室内湿度",
          num: "40",
          unit: "%",
        },
      ],
      // 鸡舍二情况
      coopList3: [
        {
          name: "蛋鸡数量",
          num: "45251",
          unit: "只",
        },
        {
          name: "鸡舍范围",
          num: "40",
          unit: "亩",
        },
        {
          name: "智能设施",
          num: "17",
          unit: "台",
        },
        {
          name: "工作人员",
          num: "40",
          unit: "人",
        },
        {
          name: "室内温度",
          num: "28",
          unit: "℃",
        },
        {
          name: "室内湿度",
          num: "50",
          unit: "%",
        },
      ],
      // 能耗分析
      energyYdata: [],
      // 能耗分析
      energyYdata1: [260, 300, 350, 340, 402],
      // 能耗分析
      energyYdata2: [160, 150, 175, 170, 202],
      energyYdata3: [240, 250, 275, 270, 352],
      // 产量分析
      production: {
        ydata1: [],
        ydata2: [],
      },
      // 产量分析
      production1: {
        ydata1: [8, 7, 8, 5, 6, 8],
        ydata2: [92, 93, 92, 95, 94, 92],
      },
      // 产量分析
      production2: {
        ydata1: [5, 4, 5, 3, 6, 5],
        ydata2: [95, 96, 95, 97, 94, 95],
      },
      // 产量分析
      production3: {
        ydata1: [4, 5, 3, 7, 5, 4],
        ydata2: [96, 95, 97, 93, 95, 96],
      },
      // 监控
      jiankUrl: "",
      jiankUrl1:
        "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AE9886941/1.hd.live&autoplay=1&accessToken=at.8d4p653o7ukfofjhdmfu6tqt7k6v91oq-969nbvbp10-0w9muta-bkuh9va9y&AppKey=248cd3b6278e41be94df07500e0a912d",
      jiankUrl2:
        "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AE9887033/1.hd.live&autoplay=1&accessToken=at.8d4p653o7ukfofjhdmfu6tqt7k6v91oq-969nbvbp10-0w9muta-bkuh9va9y&AppKey=248cd3b6278e41be94df07500e0a912d",
      jiankUrl3:
        "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AE9887101/1.hd.live&autoplay=1&accessToken=at.8d4p653o7ukfofjhdmfu6tqt7k6v91oq-969nbvbp10-0w9muta-bkuh9va9y&AppKey=248cd3b6278e41be94df07500e0a912d",
      // 企业信息
      qyDetail: {},
      qyDetail1: {
        name: "美绿思生态农牧科技馆陶有限公司",
        title:
          "美绿思生态农牧科技馆陶有限公司成立于2014年10月27日，注册地位于河北省邯郸市馆陶县寿山寺乡浅口村村北，法定代表人为张延朋。经营范围包括生态农牧技术研发、推广；畜禽养殖及销售；农副产品购销；饲料加工、销售；农作物种植、林木培育、种植及销售；畜禽、农副产品加工、销售；畜牧机械制造、销售；畜禽粪便处理与技术开发及产品销售；生物质能燃料研发、加工、销售。（依法须经批准的项目，经相关部门批准后方可开展经营活动）",
        icon: "https://img2.baidu.com/it/u=678804881,1683938396&fm=253&fmt=auto&app=138&f=JPEG?w=660&h=495",
        address: "河北省邯郸市馆陶县寿山寺乡浅口村村北",
        phone: "15831072066",
      },
      qyDetail2: {
        name: "馆陶县佳凤蛋鸡养殖专业合作社",
        title:
          "馆陶县佳凤蛋鸡养殖专业合作社成立于2009年03月02日，注册地位于馆陶县王桥乡西留庄南村，法定代表人为董怀印。经营范围包括为本社成员提供蛋鸡养殖及其相关的技术信息服务。（依法须经批准的项目，经相关部门批准后方可开展经营活动）",
        icon: "https://k.sinaimg.cn/n/sinakd20117/425/w700h525/20240529/f19f-27de6a524a35c9f549483d67bf8e2d21.jpg/w700d1q75cms.jpg?by=cms_fixed_width",
        address: "馆陶县王桥乡西留庄南村",
        phone: "15833749797",
      },
      qyDetail3: {
        name: "馆陶县百谷源养殖有限公司",
        title:
          "馆陶县百谷源养殖有限公司成立于2018年04月19日，注册地位于河北省邯郸市馆陶县柴堡镇东苏堡村村东，法定代表人为韩东勤。经营范围包括许可项目：家禽饲养。（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准）一般项目：初级农产品收购；粮食收购；食用农产品批发；食用农产品初加工；食品销售（仅销售预包装食品）；非居住房地产租赁；畜禽粪污处理利用；货物进出口。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）",
        icon: "https://img1.baidu.com/it/u=2596169694,1908580697&fm=253&fmt=auto&app=120&f=JPEG?w=578&h=433",
        address: "河北省邯郸市馆陶县柴堡镇东苏堡村村东",
        phone: "13932066686",
      },
      // 产值趋势
      cz: [],
      cz1: ["5210", "5240", "5580", "6000", "6287"],
      cz2: ["4530", "4538", "4218", "4284", "4820"],
      cz3: ["5030", "4838", "4718", "4584", "5820"],
      // 产量趋势
      cl: [],
      cl1: ["7570", "7650", "7801", "7451", "7822"],
      cl2: ["6852", "6846", "6974", "7052", "6900"],
      cl3: ["7252", "7546", "7474", "7152", "7500"],
      // 地图
      mapList: [],
      mapList1: [
        {
          name: "张延朋",
          phone: "15831072066",
          address: "河北省邯郸市馆陶县寿山寺乡浅口村村北",
          title: "美绿思生态农牧科技馆陶有限公司",
          position: {
            lng: "115.23",
            lat: "36.61",
          },
          icon: require("../../assets/dingwei.png"),
        },
      ],
      mapList2: [
        {
          name: "董怀印",
          phone: "15833749797",
          address: "馆陶县王桥乡西留庄南村",
          title: "馆陶县佳凤蛋鸡养殖专业合作社",
          position: {
            lng: "115.18",
            lat: "36.48",
          },
          icon: require("../../assets/dingwei.png"),
        },
      ],
      mapList3: [
        {
          name: "韩东勤",
          phone: "13932066686",
          address: "河北省邯郸市馆陶县柴堡镇东苏堡村村东",
          title: "馆陶县百谷源养殖有限公司",
          position: {
            lng: "115.25",
            lat: "36.62",
          },
          icon: require("../../assets/dingwei.png"),
        },
      ],
    };
  },
  created() {
    this.coopList = this.coopList1;
    this.energyYdata = this.energyYdata1;
  },
  mounted() {
    this.selectchange();
  },
  methods: {
    // 选中的鸡舍数据
    selectchange(value) {
      // console.log("选中的鸡舍数据", value);
      if (this.keyName == "美绿思生态农牧科技馆陶有限公司") {
        this.coopList = this.coopList1;
        this.energyYdata = this.energyYdata1;
        this.production.ydata1 = this.production1.ydata1;
        this.production.ydata2 = this.production1.ydata2;
        this.jiankUrl = this.jiankUrl1;
        this.qyDetail = this.qyDetail1;
        this.cz = this.cz1;
        this.cl = this.cl1;
        this.mapList = this.mapList1;
      } else if (this.keyName == "馆陶县佳凤蛋鸡养殖专业合作社") {
        this.coopList = this.coopList2;
        this.energyYdata = this.energyYdata2;
        this.production.ydata1 = this.production2.ydata1;
        this.production.ydata2 = this.production2.ydata2;
        this.jiankUrl = this.jiankUrl2;
        this.qyDetail = this.qyDetail2;
        this.cz = this.cz2;
        this.cl = this.cl2;
        this.mapList = this.mapList2;
      } else if (this.keyName == "馆陶县百谷源养殖有限公司") {
        this.coopList = this.coopList3;
        this.energyYdata = this.energyYdata3;
        this.production.ydata1 = this.production3.ydata1;
        this.production.ydata2 = this.production3.ydata2;
        this.jiankUrl = this.jiankUrl3;
        this.qyDetail = this.qyDetail3;
        this.cz = this.cz3;
        this.cl = this.cl3;
        this.mapList = this.mapList3;
      }
      // 能耗分析
      this.getEnergy();
      // 产量分析
      this.getProduction();
      // 产量趋势
      this.getComputedStyle();
      // 产值趋势
      this.getCzqs();
    },
    // 能耗分析
    getEnergy() {
      var chartDom = document.getElementById("echartsOne");
      var myChart = echarts.init(chartDom);
      var option = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "5%",
          top: "10%",
          containLabel: true,
        },
        calculable: true,
        xAxis: [
          {
            boundaryGap: false,
            type: "category",
            data: ["7-12", "7-13", "7-14", "7-15", "7-16"],
            axisLabel: {
              color: "white",
              interval: 0,
            },
            axisTick: {
              show: true,
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "white",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "white",
              formatter: "{value}°/电",
            },

            nameTextStyle: {
              color: "white",
            },
            splitLine: {
              show: true,
              lineStyle: {
                // 在 lineStyle 中设置线的样式
                color: "#02437c", // 将线的颜色设置为灰色
                opacity: 0.5,
              },
            },
          },
        ],
        series: [
          {
            name: "电量",
            type: "line",
            smooth: true,
            data: this.energyYdata,
            areaStyle: {},
            tooltip: {
              valueFormatter: function (value) {
                return value + "°/电";
              },
            },
            lineStyle: {
              // 设置线条的style等
              normal: {
                color: "#f3d321",
              },
            },
            itemStyle: {
              // 设置线条上点的颜色（和图例的颜色）
              normal: {
                color: "#f3d321",
              },
            },
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#f9c01c", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#f9c01c11", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
          },
        ],
      };
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    // 产量分析
    getProduction() {
      var echartsTwo = document.getElementById("echartsTwo");
      var myChart = echarts.init(echartsTwo);
      var option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          textStyle: {
            color: "#fff",
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "5%",
          containLabel: true,
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            data: ["1月", "2月", "3月", "4月", "5月", "6月"],
            axisLabel: {
              color: "white",
            },
            axisTick: {
              show: true,
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "white",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            // name: "%",
            axisLabel: {
              color: "white",
              formatter: "{value}%",
            },
            nameTextStyle: {
              color: "white",
            },
            splitLine: {
              show: true,
              lineStyle: {
                // 在 lineStyle 中设置线的样式
                color: "#02437c", // 将线的颜色设置为灰色
                opacity: 0.5,
              },
            },
          },
        ],
        series: [
          {
            name: "坏蛋",
            type: "bar",
            barWidth: "25%",
            data: this.production.ydata1,
            tooltip: {
              valueFormatter: function (value) {
                return value + "%";
              },
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1, // 这四个参数分别表示渐变的起点 (x1, y1) 与终点 (x2, y2)
                [
                  { offset: 0, color: "#f2c347" }, // 0% 处的颜色
                  { offset: 1, color: "#287ce7" }, // 100% 处的颜色
                ]
              ),
            },
          },
          {
            name: "好蛋",
            type: "bar",
            barWidth: "25%",
            tooltip: {
              valueFormatter: function (value) {
                return value + "%";
              },
            },
            data: this.production.ydata2,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1, // 这四个参数分别表示渐变的起点 (x1, y1) 与终点 (x2, y2)
                [
                  { offset: 0, color: "#00e8f6" }, // 0% 处的颜色
                  { offset: 1, color: "#005d62" }, // 100% 处的颜色
                ]
              ),
            },
          },
        ],
      };
      myChart.setOption(option);
      // 监听窗口大小变化
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    // 全屏播放
    iframedx() {
      const monitorVideo = this.$refs.monitorVideo;
      if (monitorVideo.requestFullscreen) {
        monitorVideo.requestFullscreen();
      } else if (monitorVideo.mozRequestFullScreen) {
        /* Firefox */
        monitorVideo.mozRequestFullScreen();
      } else if (monitorVideo.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        monitorVideo.webkitRequestFullscreen();
      } else if (monitorVideo.msRequestFullscreen) {
        /* IE/Edge */
        monitorVideo.msRequestFullscreen();
      }
    },
    // 产量趋势
    getComputedStyle() {
      var barone = document.getElementById("echarts-filt");
      var myChart = echarts.init(barone);
      var option = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "5%",
          top: "10%",
          containLabel: true,
        },
        calculable: true,
        xAxis: [
          {
            boundaryGap: false,
            type: "category",
            data: ["2019", "2020", "2021", "2022", "2023"],
            axisLabel: {
              color: "white",
              interval: 0,
            },
            axisTick: {
              show: true,
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "white",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "white",
              formatter: "{value}吨",
            },

            nameTextStyle: {
              color: "white",
            },
            splitLine: {
              show: true,
              lineStyle: {
                // 在 lineStyle 中设置线的样式
                color: "#02437c", // 将线的颜色设置为灰色
                opacity: 0.5,
              },
            },
          },
        ],
        series: [
          {
            name: "产量",
            type: "line",
            smooth: true,
            data: this.cl,
            areaStyle: {},
            tooltip: {
              valueFormatter: function (value) {
                return value + "吨";
              },
            },
            lineStyle: {
              // 设置线条的style等
              normal: {
                color: "#f58356",
              },
            },
            itemStyle: {
              // 设置线条上点的颜色（和图例的颜色）
              normal: {
                color: "#f58356",
              },
            },
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#f58356", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#f5835611", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
          },
        ],
      };
      myChart.setOption(option);
      // 监听窗口大小变化
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    // 产值趋势
    getCzqs() {
      var barone = document.getElementById("echarts-three");
      var myChart = echarts.init(barone);
      var option = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "5%",
          top: "10%",
          containLabel: true,
        },
        calculable: true,
        xAxis: [
          {
            boundaryGap: false,
            type: "category",
            data: ["2019", "2020", "2021", "2022", "2023"],
            axisLabel: {
              color: "white",
              interval: 0,
            },
            axisTick: {
              show: true,
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "white",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "white",
              formatter: "{value}万/元",
            },

            nameTextStyle: {
              color: "white",
            },
            splitLine: {
              show: true,
              lineStyle: {
                // 在 lineStyle 中设置线的样式
                color: "#02437c", // 将线的颜色设置为灰色
                opacity: 0.5,
              },
            },
          },
        ],
        series: [
          {
            name: "产值",
            type: "line",
            smooth: true,
            tooltip: {
              valueFormatter: function (value) {
                return value + "万/元";
              },
            },
            data: this.cz,
            areaStyle: {},
            lineStyle: {
              // 设置线条的style等
              normal: {
                color: "#38e9a0",
              },
            },
            itemStyle: {
              // 设置线条上点的颜色（和图例的颜色）
              normal: {
                color: "#38e9a0",
              },
            },
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#38e9a0", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#38e9a011", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
          },
        ],
      };

      myChart.setOption(option);
      // 监听窗口大小变化
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
  },
};
</script>
<style lang="scss">
.BMap_bottom {
  display: none;
}
.BMap_pop {
  > div,
  > img:nth-child(10) {
    display: none;
    overflow: unset;
  }
  > div:nth-child(9) {
    display: block;
    overflow: unset;
    width: 340px !important;
  }
  .BMap_top {
    display: none;
  }
  .BMap_center {
    background: transparent;
    border: none;
    position: sticky !important;
    height: 100%;
  }
}
.BMap_bubble_content {
  border-radius: 5px;
  padding: 20px;
  .info-window {
    padding-right: 8px;
    width: 100%;
    max-height: 280px;
    overflow: auto;
    .address {
      color: #fff;
    }
  }
}
</style>
<style lang="scss" scoped>
.custom-select ::v-deep .el-input__inner {
  background-color: #03173a29 !important;
  border: 1px solid #009fe8 !important;
  border-radius: 30px !important;
  color: #fff !important;
  text-align: center !important;
  font-weight: 600;
  font-size: 20px;
}

/* // 设置下拉框的背景颜色及边框属性； */
.custom-select ::v-deep .el-select-dropdown {
  /* // 若不将下拉框的背景颜色设置为：transparent，那么做不出来半透明的效果；
  // 因为其最终的显示为：下拉框有一个背景颜色且下拉框的字体有一个背景颜色，重叠后的效果展示； */
  border: 1px solid #009fe8 !important;
  background: #03173a !important;
}

/* // 设置下拉框的字体属性及背景颜色； */
.custom-select .el-select-dropdown__item {
  color: #fff;
  background-color: #03173a !important;
  font-size: 20px;
}

/* // 将下拉框上的小箭头取消；(看着像一个箭头，其实是两个重叠在一起的箭头) */
.custom-select ::v-deep .el-input__icon,
.custom-select ::v-deep .el-input__icon ::after {
  color: #009fe8 !important;
}

/* // 设置鼠标悬停在下拉框列表的悬停色； */
.custom-select ::v-deep .el-select-dropdown__item:hover {
  color: rgb(213, 215, 230);
  background-color: #326aff !important;
}
</style>
<style lang="scss" scoped>
.map {
  width: 100%;
  height: 100%;
}
.info {
  background: url(~@/assets/info.png) no-repeat center center;
  background-size: 100% 100%;
  color: #fff;
  padding: 0px 10px 20px;
  position: relative;
  font-size: 18px;
  font-weight: 600;
}
#views-page1 {
  box-sizing: border-box;
  background: url(~@/assets/background-img.png) no-repeat center center;
  background-size: 100% 100%;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
}
// 内容
.content {
  color: #fff;
  width: 100%;
  height: 90%;
  box-sizing: border-box;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // 左
  .left {
    width: 28%;
    height: 100%;
    background-image: url("../../assets/suyuan/left.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    // 鸡舍情况
    .jsqk-title {
      font-size: 18px;
      font-weight: 600;
      background: linear-gradient(90deg, #022f51, rgba(2, 47, 81, 0));
      width: 100%;
      height: 35px;
      line-height: 35px;
      box-sizing: border-box;
      border-bottom: 3px solid #0064b0;
    }
    .jsqk {
      display: flex;
      width: 100%;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
      .jsqk-item {
        display: flex;
        width: 49%;
        height: 80px;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        margin-bottom: 10px;
        &:nth-child(1) {
          box-shadow: 0 0 5px 0 #24d86e;
          background-color: #24d86f1a;
          div {
            &:nth-child(2) {
              span {
                &:nth-child(1) {
                  color: #24d86e;
                }
              }
            }
          }
        }
        &:nth-child(2) {
          box-shadow: 0 0 5px 0 #f3d009;
          background-color: #f3d3211a;
          div {
            &:nth-child(2) {
              span {
                &:nth-child(1) {
                  color: #ffda06;
                }
              }
            }
          }
        }
        &:nth-child(3) {
          box-shadow: 0 0 5px 0 #e74032;
          background-color: #e740321a;
          div {
            &:nth-child(2) {
              span {
                &:nth-child(1) {
                  color: #e74032;
                }
              }
            }
          }
        }
        &:nth-child(4) {
          box-shadow: 0 0 5px 0 #02b1fe;
          background-color: #02b1fe1a;
          div {
            &:nth-child(2) {
              span {
                &:nth-child(1) {
                  color: #02b1fe;
                }
              }
            }
          }
        }
        &:nth-child(5) {
          box-shadow: 0 0 5px 0 #dd8b18;
          background-color: #dd8b181a;
          div {
            &:nth-child(2) {
              span {
                &:nth-child(1) {
                  color: #dd8b18;
                }
              }
            }
          }
        }
        &:nth-child(6) {
          box-shadow: 0 0 5px 0 #d91ec6;
          background-color: #d91ec61a;
          div {
            &:nth-child(2) {
              span {
                &:nth-child(1) {
                  color: #d91ec6;
                }
              }
            }
          }
        }
        div {
          font-weight: 600;
          font-size: 18px;
          letter-spacing: 2px;
          &:nth-child(2) {
            span {
              &:nth-child(1) {
                font-weight: 600;
                font-size: 28px;
                letter-spacing: 2px;
              }
            }
          }
        }
      }
    }
  }
  // 中间
  .center {
    width: 42%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    .center-one {
      width: 100%;
      height: 66%;
    }
    // 企业介绍
    .center-two {
      width: 100%;
      height: 33%;
      margin-top: 10px;
      background-image: url("../../assets/cockpit/back-1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .center-two-list {
        width: 96%;
        display: flex;
        margin: 20px auto 0;
        height: 100%;
        justify-content: space-between;
        img {
          width: 300px;
          height: 255px;
          border-radius: 5px;
          display: block;
        }
        .center-two-item {
          width: 58%;
          letter-spacing: 2px;
          font-size: 18px;
          font-weight: 600;
          line-height: 29px;
        }
      }
    }
  }
  // 右
  .right {
    width: 28%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // 监控
    .right-one {
      width: 100%;
      height: 32%;
      background-image: url("../../assets/cockpit/back-1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      // 鸡舍监控
      .jiankabsolute {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 50px;
        text-align: center;
        background-color: #0000006a;
        z-index: 99;
        letter-spacing: 3px;
        font-size: 20px;
        font-weight: 600;
        line-height: 50px;
      }
    }
    // 产值趋势
    .right-two {
      width: 100%;
      height: 32%;
      background-image: url("../../assets/cockpit/back-1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    // 产量趋势
    .right-three {
      width: 100%;
      height: 32%;
      background-image: url("../../assets/cockpit/back-1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
}
// 模块名称
.title {
  font-size: 20px;
  letter-spacing: 2px;
  font-weight: bold;
  background: linear-gradient(to bottom, #ffffff, #a3dcff);
  -webkit-background-clip: text !important;
  background-clip: text;
  color: transparent;
  padding: 13px 0 0 40px;
}
</style>
